import React, { ReactElement } from "react";
import { CSVLink } from "react-csv";
import { ProcessedAdsByClusterRecord } from "../../../redux/types/reportTypes";
import { FileExcelOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const headers = [
  {
    label: "Cluster",
    key: "cluster",
  },
  {
    label: "Period 1",
    key: "period1",
  },
  {
    label: "Period 2",
    key: "period2",
  },
  {
    label: "Difference",
    key: "difference",
  },
  {
    label: "Percentual Difference",
    key: "percentualDifference",
  },
];

type ClusterCSVProps = {
  data: Array<ProcessedAdsByClusterRecord>;
};

const ClusterCSV = ({ data }: ClusterCSVProps): ReactElement => (
  <CSVLink data={data} headers={headers}>
    <Button type="dashed" icon={<FileExcelOutlined />} />
  </CSVLink>
);

export default ClusterCSV;
